import { clsx } from 'clsx'
import styles from './LeagueHighlights.module.css'

export type HighlightItem = {
  icon: string
  label: string
  value: string
  sub?: string
  accent?: boolean
}

type LeagueHighlightsProps = {
  items: HighlightItem[]
}

export function LeagueHighlights({ items }: LeagueHighlightsProps) {
  if (items.length === 0) return null

  return (
    <div className={styles.card}>
      <div className={styles.head}>
        <span className={styles.title}>Destaques da liga</span>
      </div>
      {items.map((item) => (
        <div key={item.label} className={styles.row}>
          <span className={styles.icon} aria-hidden="true">{item.icon}</span>
          <div className={styles.content}>
            <div className={styles.label}>{item.label}</div>
            <div className={clsx(styles.value, item.accent && styles.valueAccent)}>{item.value}</div>
            {item.sub !== undefined && <div className={styles.sub}>{item.sub}</div>}
          </div>
        </div>
      ))}
    </div>
  )
}
